import media from './media';

const theme = {
	media,
	shadow: '0 0 2rem 0 rgba(136, 152, 170, 0.15)',
	font: {
		xs: '14px',
		sm: '16px',
		md: '18px',
		lg: '24px',
		bold: '600',
		regular: '500',
		light: '400',
	},
	colors: {
		primary: '#2083fe',
		success: '#2fca74',
		info: '#f5b848',
		danger: '#ed4d4d',
		textPrimary: '#252529',
		secondary: '#768093',
		grey: '#e1e2e8',
		lightGrey: '#f4f6f9',
		white: '#fff',
	},
};

export default theme;
